import { useEffect, useRef, useCallback } from "react";

const useAutoFitText = (text, { maxFontRem = 1.4, minFontRem = 0.8, mobileOnly = true } = {}) => {
  const containerRef = useRef(null);
  const textRef = useRef(null);

  const fit = useCallback(() => {
    const container = containerRef.current;
    const textEl = textRef.current;
    if (!container || !textEl) return;

    if (mobileOnly && window.innerWidth > 1280) {
      textEl.style.fontSize = "";
      textEl.style.overflow = "";
      textEl.style.textOverflow = "";
      textEl.style.display = "";
      textEl.style.webkitLineClamp = "";
      textEl.style.webkitBoxOrient = "";
      return;
    }

    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
    let current = maxFontRem;

    textEl.style.overflow = "";
    textEl.style.textOverflow = "";
    textEl.style.display = "";
    textEl.style.webkitLineClamp = "";
    textEl.style.webkitBoxOrient = "";
    textEl.style.fontSize = `${current}rem`;

    while (textEl.scrollHeight > container.clientHeight && current > minFontRem) {
      current = Math.max(minFontRem, current - 0.05);
      textEl.style.fontSize = `${current}rem`;
    }

    if (textEl.scrollHeight > container.clientHeight) {
      textEl.style.overflow = "hidden";
      textEl.style.textOverflow = "ellipsis";
      textEl.style.display = "-webkit-box";
      textEl.style.webkitBoxOrient = "vertical";
      const lineHeight = parseFloat(getComputedStyle(textEl).lineHeight);
      const maxLines = Math.floor(container.clientHeight / lineHeight);
      textEl.style.webkitLineClamp = `${maxLines}`;
    }
  }, [text, maxFontRem, minFontRem, mobileOnly]);

  useEffect(() => {
    fit();
  }, [fit]);

  useEffect(() => {
    window.addEventListener("resize", fit);
    return () => window.removeEventListener("resize", fit);
  }, [fit]);

  return { containerRef, textRef };
};

export default useAutoFitText;
